<div class="c-modal c-modal--md">
	<div mat-dialog-content class="c-modal__dialog">
		<div class="c-modal__header">
			<div class="o-grid">
				<div class="o-grid__cell u-no-p"></div>
				<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
					<button id="closeButton" class="c-button c-button--icon c-button--tp c-modal__close" (click)="vm.close()">
						<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
						<span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
					</button>
				</div>
			</div>
		</div>
		<div class="c-modal__content u-no-pt">
			<div class="c-card c-card--height-fit" style="box-shadow:none;">
				<p class="c-text c-text--bold">{{ 'Questionnaire_Search.Description' | translate }}</p>
				<form name="vm.form" class="c-form u-ost-md">
					<div class="o-grid__cell o-grid__cell--w-100 u-no-p">
						<div class="c-form__group u-no-m">
							<label for="lang" class="c-form__label">{{ 'Services.Filter.Languages' | translate }}</label>
							<mat-select style="border: 1px solid #d1d1d1;" [(value)]="vm.selectedLang" class="mat-select" id="lang" placeholder="{{ 'Services.Filter.Languages' | translate }}" data-md-container-class="mat-select-menu2">
								<mat-option id="language{{$index}}" *ngFor="let lang of vm.searchLanguages ; let $index=index" [value]="lang">{{ lang }}</mat-option>
								<mat-select-trigger>{{ vm.getLanguagesText() }}</mat-select-trigger>
							</mat-select>
						</div>
						<div style="margin-top:10px !important;" class="c-form__group u-no-m" *ngIf="vm.questionnaires">
	                        <label for="tags" class="c-form__label">{{ 'Services.Filter.Questionnaire' | translate }}</label>
	                        <mat-select style="border: 1px solid #d1d1d1;" [(value)]="vm.selectedQuestionnaire" class="mat-select" id="questionnaires" placeholder="{{ 'Services.Filter.Questionnaire' | translate }}" data-md-container-class="mat-select-menu2">
	                            <mat-option id="questionnaire{{$index}}" *ngFor="let questionnaire of vm.questionnaires ; let $index=index" [value]="questionnaire">{{ questionnaire.codeName }}{{ questionnaire.shortDescription ? ' - ' + questionnaire.shortDescription : ''}}</mat-option>
	                        	<mat-select-trigger>{{ vm.getQuestionnaireText() }}</mat-select-trigger>
	                        </mat-select>
	                    </div>
					</div>
				</form>
				<div class="o-grid">
					<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-p u-ost-md">
						<button id="questionnaireSearchSubmitButton" type="button" class="c-button c-button--s2 c-button--fit" (click)="vm.submit()" [disabled]="vm.processing || !vm.initialized">{{ 'Common.Send' | translate }}</button>
					</div>
				</div>
				<loader-overlay *ngIf="vm.processing || !vm.initialized"></loader-overlay>
			</div>
		</div>
	</div>
</div>
